// extracted by mini-css-extract-plugin
export var button = "_62-4";
export var hasDarkBackground = "_62-7";
export var hasLightBackground = "_62-6";
export var iconWrapper = "_62-0";
export var large = "_62-2";
export var medium = "_62-1";
export var small = "_62-5";
export var xsmall = "_62-3";